import { useBreakpoints } from "@vueuse/core";

/**
 * The Tailwind CSS breakpoints use `rem`. We then assume that the root font size is `16px`.
 * Therefore, we convert the Tailwind CSS breakpoints to `px` by multiplying them by `16`.
 *
 * Reference: https://tailwindcss.com/docs/responsive-design#default-breakpoints
 */
const fontSize = 16; // In pixels

const customTailwindBreakpoints = {
  // Special breakpoint for anything below the smallest breakpoint ("3xs")
  "mobile": 0,

  "sm": 40 * fontSize,
  "md": 48 * fontSize,
  "lg": 64 * fontSize,
  "xl": 80 * fontSize,
  "2xl": 96 * fontSize,
} as const;

export const breakpoints = useBreakpoints(customTailwindBreakpoints);
